import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, AlertController } from '@ionic/angular';
import { ProductService } from '../../services/product.service';
import { CartService } from '../../services/cart.service';
import { ObserverService } from '../../services/observer.service';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: "app-select-sub-product",
    templateUrl: "./select-sub-product.page.html",
    styleUrls: ["./select-sub-product.page.scss"],
})
export class SelectSubProductPage implements OnInit {

    cart = null;
    product = null;
    sub_products = null;
    show_sku = false;

    constructor(
        public modalController: ModalController,
        public navParams: NavParams,
        public alertController: AlertController,
        private cartService: CartService,
        private productService: ProductService,
        private observerService: ObserverService,
        private storageService: StorageService
    ) { }

    ngOnInit() {

        if (this.navParams.get("product")) {
            this.product = this.navParams.get("product");
        }

        this.storageService.get("show_sku").then((show_sku) => {
            this.show_sku = show_sku;
        })

        this.cartService.get().then((cart) => {
            this.cart = cart;
        })
        .catch(() => {});

        this.productService.getSubProducts(this.product.id).then((sub_products: any) => {

            for (let i = 0; i < sub_products.length; i++) {
                sub_products[i].order = '';
                for (let j = 0; j < sub_products[i].variations.length; j++) {
                    sub_products[i].order += sub_products[i].variations[j].attribute.order.toString();
                    if(j < sub_products[i].variations.length - 1) {
                        sub_products[i].order += '.';
                    }
                }
            }

            sub_products.sort((a, b) => {
                if (a.order < b.order) { return -1; }
                if (a.order > b.order) { return 1; }
                return 0;
            });

            for (let i = 0; i < sub_products.length; i++) { 
                sub_products[i] = this.addSellPriceToSubProduct(sub_products[i]);
            } 

            this.sub_products = sub_products;

        })
        .catch((error) => {
            console.error(error);
        });

        this.observerService.subscribe('product_deleted|select_sub_product_modal', (product) => {
            if (this.product.id = product.id) {
                this.modalController.dismiss();
            }
        });

        this.observerService.subscribe('product_updated|select_sub_product_modal', (product) => {
            if (this.product.id = product.id) {
                this.product = product;
            }
        });

        this.observerService.subscribe('sub_product_added|select_sub_product_modal', (sub_product) => {
            if (sub_product.product_id === this.product.id) {
                sub_product = this.addSellPriceToSubProduct(sub_product);
                this.sub_products.push(sub_product);
                // NOTE: we don't re-sort at this point, as it would clause jank
            }
        });

        this.observerService.subscribe('sub_product_deleted|select_sub_product_modal', (sub_product) => {
            if (sub_product.product_id === this.product.id) {
                for (let i = 0; i < this.sub_products.length; i++) {
                    if (this.sub_products[i].id === sub_product.id) {
                        this.sub_products.splice(i, 1);
                        break;
                    }
                }
            }
        });

        this.observerService.subscribe('sub_product_updated|select_sub_product_modal', (sub_product) => {
            if (sub_product.product_id === this.product.id) {
                for (let i = 0; i < this.sub_products.length; i++) {
                    if (this.sub_products[i].id === sub_product['id']) {
                        sub_product = this.addSellPriceToSubProduct(sub_product);
                        this.sub_products[i] = sub_product;
                        break;
                    }
                }
            }
        });

        this.observerService.subscribe('sub_product_availabe_stock_updated|select_sub_product_modal', (sub_product) => {
            if (sub_product.product_id === this.product.id) {
                for (let i = 0; i < this.sub_products.length; i++) {
                    if (this.sub_products[i].id === sub_product['id']) {
                        this.sub_products[i].available_stock = sub_product.available_stock;
                        break;
                    }
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("product_deleted|select_sub_product_modal");
        this.observerService.destroy("product_updated|select_sub_product_modal");
        this.observerService.destroy("sub_product_added|select_sub_product_modal");
        this.observerService.destroy("sub_product_deleted|select_sub_product_modal");
        this.observerService.destroy("sub_product_updated|select_sub_product_modal");
        this.observerService.destroy("sub_product_availabe_stock_updated|select_sub_product_modal");
    }

    addSubProduct(sub_product_id) {
        this.storageService.get("close_sub_product_modal").then((close_sub_product_modal) => {
            this.cartService.addSubProductItem(sub_product_id).then(() => {
                if (close_sub_product_modal && close_sub_product_modal == true) {
                    this.modalController.dismiss();
                }
            })
            .catch(() => { });
        })
        .catch((error) => {
            console.error(error)
        });
    }

    close() {
        this.modalController.dismiss();
    }

    addSellPriceToSubProduct(sub_product) {
        delete sub_product['sell_price'];
        delete sub_product['has_contract_price'];
        if(this.cart['person'] && this.cart["organisation"] && this.cart["organisation"].contract_prices[this.cart['currency'].id] && this.cart["organisation"].contract_prices[this.cart['currency'].id][sub_product.id]) {
            sub_product['sell_price'] = this.cart["organisation"].contract_prices[this.cart['currency'].id][sub_product.id];
            sub_product['has_contract_price'] = true;
        }
        else {
            if (sub_product['prices']) {
                for (let i = 0; i < sub_product['prices'].length; i++) {
                    if (sub_product['prices'][i].currency.id === this.cart['currency'].id) {
                        for (let j = 0; j < sub_product['prices'][i].pricing_tiers.length; j++) {
                            if (sub_product['prices'][i].pricing_tiers[j].id === this.cart['pricing_tier'].id) {
                                sub_product['sell_price'] = sub_product['prices'][i].pricing_tiers[j].price;
                                break;
                            }
                        }
                        break;
                    }
                }
            }
        }
        return sub_product;
    }

    subProductClicked(sub_product) {
        this.storageService.get("alert_if_overselling_item").then((alert_if_overselling_item) => {
            if (alert_if_overselling_item == true && sub_product.track_stock == true) {
                if (sub_product.available_stock <= 0) {
                    this.presentOversellingSubProductConfirmation(sub_product.id);
                } else {
                    let available_stock = sub_product.available_stock;
                    this.cartService.get().then((cart) => {
                        if (cart && cart['items'].length) {
                            for (let i = 0; i < cart['items'].length; i++) {
                                if (cart['items'][i].id == sub_product.id) {
                                    available_stock = (available_stock - cart['items'][i].quantity);
                                    break
                                }
                            }
                            if (available_stock <= 0) {
                                this.presentOversellingSubProductConfirmation(sub_product.id);
                            } else {
                                this.addSubProduct(sub_product.id);
                            }
                        } else {
                            this.addSubProduct(sub_product.id);
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                    });
                }
            } else {
                this.addSubProduct(sub_product.id);
            }
        })
        .catch((error) => {
            console.error(error)
        });
    }

    async presentOversellingSubProductConfirmation(sub_product_id) {
        const alert = await this.alertController.create({
            header: 'No available stock left',
            message: 'Are you sure you want to oversell this item?',
            buttons: [
                {
                    text: 'Cancel',
                    handler: () => {
                        this.storageService.get("close_sub_product_modal").then((close_sub_product_modal) => {
                            if (close_sub_product_modal && close_sub_product_modal == true) {
                                this.modalController.dismiss();
                            }
                        })
                        .catch((error) => {
                            console.error(error)
                        });
                    }
                },
                {
                    text: 'Yes',
                    handler: () => {
                        this.addSubProduct(sub_product_id);
                    }
                }
            ],
        });
        await alert.present();
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

}
